<template>
    <div>
        <table class="kgr-table kgr-table--block">
            <thead>
                <tr class="kgr-table__row">
                    <th
                        class="kgr-table__cell--headline bordered"
                        colspan="2"
                    >
                        {{ $t('kindergarten.feeTable.income') }}
                    </th>
                    <th
                        class="kgr-table__cell--headline bordered"
                        colspan="2"
                    >
                        {{ $t('kindergarten.feeTable.dailyHours') }}
                    </th>
                    <th
                        v-if="usingChildrenInCare"
                        class="kgr-table__cell--headline bordered"
                        colspan="2"
                    >
                        {{ $t('Kinder in Betreuung') }}
                    </th>
                    <th
                        class="kgr-table__cell--headline"
                        colspan="5"
                    >
                        {{ $t('kindergarten.feeTable.chargeLevel') }}
                    </th>
                    <th class="kgr-table__cell--headline"></th>
                </tr>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell--headline">
                        {{ $t('von') }}
                    </th>
                    <th class="kgr-table__cell--headline bordered">
                        {{ $t('bis') }} <kgr-icon-info
                            small
                            :title="$t('kindergarten.feeTable.incomeToNote')"
                            class="icon-info-position"
                        />
                    </th>
                    <th class="kgr-table__cell--headline">
                        {{ $t('von') }}
                    </th>
                    <th class="kgr-table__cell--headline bordered">
                        {{ $t('bis') }} <kgr-icon-info
                            small
                            :title="$t('kindergarten.feeTable.dailyHoursToNote')"
                            class="icon-info-position"
                        />
                    </th>
                    <th v-if="usingChildrenInCare" class="kgr-table__cell--headline">
                        {{ $t('von') }}
                    </th>
                    <th v-if="usingChildrenInCare" class="kgr-table__cell--headline bordered">
                        {{ $t('bis') }} <kgr-icon-info
                            small
                            :title="$t('kindergarten.feeTable.childrenInCareNote')"
                            class="icon-info-position"
                        />
                    </th>

                    <th class="kgr-table__cell--headline">
                        1
                    </th>
                    <th class="kgr-table__cell--headline">
                        2
                    </th>
                    <th class="kgr-table__cell--headline">
                        3
                    </th>
                    <th class="kgr-table__cell--headline">
                        4
                    </th>
                    <th class="kgr-table__cell--headline">
                        5
                    </th>
                    <th class="kgr-table__cell--headline"></th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(feeTableValue, index) in allValues">
                    <tr
                        v-if="feeTableValue.id != null"
                        class="kgr-table__row"
                        :class="{ 'fee-table-value-delete': feeTableValue.deleted, 'fee-table-value-invalid': rowError(index) }"
                    >
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="feeTableValue.income.min"
                                :error="fieldError(index, 'income.min')"
                                @post-input="onInput(feeTableValue, 'income.min')"
                                @error="onError($event, feeTableValue, 'income.min')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="feeTableValue.income.max"
                                :error="fieldError(index, 'income.max')"
                                @post-input="onInput(feeTableValue, 'income.max')"
                                @error="onError($event, feeTableValue, 'income.max')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-number-input
                                v-model="feeTableValue.dailyHours.min"
                                integer-only
                                :error="fieldError(index, 'dailyHours.min')"
                                @post-input="onInput(feeTableValue, 'dailyHours.min')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-number-input
                                v-model="feeTableValue.dailyHours.max"
                                integer-only
                                :error="fieldError(index, 'dailyHours.max')"
                                @post-input="onInput(feeTableValue, 'dailyHours.max')"
                            />
                        </td>
                        <td v-if="usingChildrenInCare" class="kgr-table__cell">
                            <kgr-number-input
                                v-model="feeTableValue.childrenInCare.min"
                                integer-only
                                :error="fieldError(index, 'childrenInCare.min')"
                                @post-input="onInput(feeTableValue, 'childrenInCare.min')"
                            />
                        </td>
                        <td v-if="usingChildrenInCare" class="kgr-table__cell">
                            <kgr-number-input
                                v-model="feeTableValue.childrenInCare.max"
                                integer-only
                                allow-null
                                :error="fieldError(index, 'childrenInCare.max')"
                                @post-input="onInput(feeTableValue, 'childrenInCare.max')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="feeTableValue.chargeLevel1"
                                required
                                :error="fieldError(index, 'chargeLevel1')"
                                @post-input="onInput(feeTableValue, 'chargeLevel1')"
                                @error="onError($event, feeTableValue, 'chargeLevel1')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="feeTableValue.chargeLevel2"
                                required
                                :error="fieldError(index, 'chargeLevel2')"
                                @post-input="onInput(feeTableValue, 'chargeLevel2')"
                                @error="onError($event, feeTableValue, 'chargeLevel2')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="feeTableValue.chargeLevel3"
                                required
                                :error="fieldError(index, 'chargeLevel3')"
                                @post-input="onInput(feeTableValue, 'chargeLevel3')"
                                @error="onError($event, feeTableValue, 'chargeLevel3')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="feeTableValue.chargeLevel4"
                                required
                                :error="fieldError(index, 'chargeLevel4')"
                                @post-input="onInput(feeTableValue, 'chargeLevel4')"
                                @error="onError($event, feeTableValue, 'chargeLevel4')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="feeTableValue.chargeLevel5"
                                required
                                :error="fieldError(index, 'chargeLevel5')"
                                @post-input="onInput(feeTableValue, 'chargeLevel5')"
                                @error="onError($event, feeTableValue, 'chargeLevel5')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-delete
                                v-if="!feeTableValue.deleted && isRemovable"
                                @click="markDeleted(index)"
                            />
                            <kgr-undo
                                v-if="feeTableValue.deleted"
                                @click="unmarkDeleted(index)"
                            />
                        </td>
                    </tr>
                    <tr
                        v-if="feeTableValue.id != null && rowError(index) && !feeTableValue.deleted"
                        class="kgr-table__row fee-table-value-invalid bordered"
                    >
                        <td
                            :colspan="usingChildrenInCare ? 12 : 10"
                            class="kgr-table__cell kgr-color kgr-color--error"
                        >
                            {{ rowError(index) }}
                        </td>
                    </tr>
                </template>

                <template v-for="(newFeeTableValue, index) in allValues">
                    <tr
                        v-if="newFeeTableValue.id == null"
                        class="kgr-table__row"
                        :class="{ 'fee-table-value-invalid': rowError(index) }"
                    >
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="newFeeTableValue.income.min"
                                label=""
                                :error="fieldError(index, 'income.min')"
                                @post-input="onInput(newFeeTableValue, 'income.min')"
                                @error="onError($event, newFeeTableValue, 'income.min')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="newFeeTableValue.income.max"
                                label=""
                                :error="fieldError(index, 'income.max')"
                                @post-input="onInput(newFeeTableValue, 'income.max')"
                                @error="onError($event, newFeeTableValue, 'income.max')"
                            />
                        </td>

                        <td class="kgr-table__cell">
                            <kgr-number-input
                                v-model="newFeeTableValue.dailyHours.min"
                                integer-only
                                label=""
                                :error="fieldError(index, 'dailyHours.min')"
                                @post-input="onInput(newFeeTableValue, 'dailyHours.min');"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-number-input
                                v-model="newFeeTableValue.dailyHours.max"
                                integer-only
                                label=""
                                :error="fieldError(index, 'dailyHours.max')"
                                @post-input="onInput(newFeeTableValue, 'dailyHours.max')"
                            />
                        </td>
                        <td v-if="usingChildrenInCare" class="kgr-table__cell">
                            <kgr-number-input
                                v-model="newFeeTableValue.childrenInCare.min"
                                integer-only
                                label=""
                                :error="fieldError(index, 'childrenInCare.min')"
                                @post-input="onInput(newFeeTableValue, 'childrenInCare.min')"
                            />
                        </td>
                        <td v-if="usingChildrenInCare" class="kgr-table__cell">
                            <kgr-number-input
                                v-model="newFeeTableValue.childrenInCare.max"
                                integer-only
                                allow-null
                                label=""
                                :error="fieldError(index, 'childrenInCare.max')"
                                @post-input="onInput(newFeeTableValue, 'childrenInCare.max')"
                            />
                        </td>

                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="newFeeTableValue.chargeLevel1"
                                required
                                :error="fieldError(index, 'chargeLevel1')"
                                @post-input="onInput(newFeeTableValue, 'chargeLevel1')"
                                @error="onError($event, newFeeTableValue, 'chargeLevel1')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="newFeeTableValue.chargeLevel2"
                                required
                                :error="fieldError(index, 'chargeLevel2')"
                                @post-input="onInput(newFeeTableValue, 'chargeLevel2')"
                                @error="onError($event, newFeeTableValue, 'chargeLevel2')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="newFeeTableValue.chargeLevel3"
                                required
                                :error="fieldError(index, 'chargeLevel3')"
                                @post-input="onInput(newFeeTableValue, 'chargeLevel3')"
                                @error="onError($event, newFeeTableValue, 'chargeLevel3')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="newFeeTableValue.chargeLevel4"
                                required
                                :error="fieldError(index, 'chargeLevel4')"
                                @post-input="onInput(newFeeTableValue, 'chargeLevel4')"
                                @error="onError($event, newFeeTableValue, 'chargeLevel4')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-money-input
                                v-model="newFeeTableValue.chargeLevel5"
                                required
                                :error="fieldError(index, 'chargeLevel5')"
                                @post-input="onInput(newFeeTableValue, 'chargeLevel5')"
                                @error="onError($event, newFeeTableValue, 'chargeLevel5')"
                            />
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-delete
                                v-if="isRemovable"
                                @click="remove(index)"
                            />
                        </td>
                    </tr>
                    <tr
                        v-if="newFeeTableValue.id == null && rowError(index) && !newFeeTableValue.deleted"
                        class="kgr-table__row fee-table-value-invalid bordered"
                    >
                        <td
                            :colspan="usingChildrenInCare ? 12 : 10"
                            class="kgr-table__cell kgr-color kgr-color--error"
                        >
                            {{ rowError(index) }}
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <br />
        <kgr-button
            class="kgr-float--right"
            @click="addNewFeeTableValue()"
        >
            {{ $t('newEntry') }}
        </kgr-button>
        <br />
        <br />
        <br />
    </div>
</template>

<script>
import Error from '../../js/model/Error';
import FeeTable from '../../js/dto/FeeTable';
import FeeTableValue from '../../js/dto/FeeTableValue';
import KgrButton from '../common/form/button/KgrButton';
import KgrDelete from '../../components/common/icon/IconDelete';
import KgrIconInfo from '../../components/common/icon/IconInfo';
import KgrMoneyInput from '../common/form/input/MoneyInput';
import KgrNumberInput from '../common/form/input/NumberInput';
import KgrReset from '../../components/common/icon/IconReset';

export default {
    components: {
        'kgr-undo': KgrReset,
        'kgr-delete': KgrDelete,
        'kgr-button': KgrButton,
        'kgr-icon-info': KgrIconInfo,
        'kgr-number-input': KgrNumberInput,
        'kgr-money-input': KgrMoneyInput,
    },
    props: {
        feeTable: {
            type: FeeTable,
            required: true,
        },
        currency: {
            type: String,
            required: false,
            default: 'EUR',
        },
        error: {
            type: Error,
            required: false,
        },
    },
    data() {
        return {
            persistedValues: [],
            newValues: [],
        };
    },
    computed: {
        allValues() {
            return this.persistedValues.concat(this.newValues);
        },
        isRemovable() {
            return this.persistedValues.concat(this.newValues).filter((value) => !value.deleted).length > 1;
        },
        usingChildrenInCare() {
            return this.feeTable.usingChildrenInCare;
        },
    },
    watch: {
        feeTable() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        onError(message, feeTableValue, field) {
            this.clearFieldErrors(feeTableValue, field);
            this.addFieldError(feeTableValue, field, message);
            this.emitInput();
            this.$forceUpdate();
        },
        onInput(feeTableValue, field) {
            this.clearFieldErrors(feeTableValue, field);
            this.checkDailyHours(feeTableValue);
            this.checkChildrenInCare(feeTableValue);
            this.$forceUpdate();
            this.emitInput();
        },
        emitInput() {
            const values = this.persistedValues.concat(this.newValues);
            this.$emit('input', values);
            this.$nextTick(() => {
                this.$emit('post-input', values);
            });
        },
        rowError(index) {
            const propertyPath = `feeTable.values[${index}]`;
            if (this.error != null && this.error.messageForField(propertyPath, true)) {
                return this.error.messageForField(propertyPath, true);
            }
        },
        getPropertyPath(field, index) {
            return `feeTable.values[${index}].${field}`;
        },
        fieldError(index, field) {
            const propertyPath = this.getPropertyPath(field, index);
            if (this.error != null && this.error.messageForField(propertyPath)) {
                return this.error.messageForField(propertyPath);
            }

            return null;
        },
        clearFieldErrors(feeTableValue, field) {
            const index = this.allValues.findIndex((e) => e === feeTableValue);
            this.error.clear(this.getPropertyPath(field, index));
        },
        addFieldError(feeTableValue, field, message) {
            const index = this.allValues.findIndex((e) => e === feeTableValue);
            const propertyPath = this.getPropertyPath(field, index);
            this.error.clear(propertyPath);
            this.error.add(propertyPath, message);
        },
        checkDailyHours(feeTableValue) {
            if (feeTableValue.dailyHours.min != null && feeTableValue.dailyHours.max != null) {
                this.clearFieldErrors(feeTableValue, 'dailyHours.min');
                this.clearFieldErrors(feeTableValue, 'dailyHours.max');
                if (feeTableValue.dailyHours.max < feeTableValue.dailyHours.min) {
                    this.addFieldError(feeTableValue, 'dailyHours.max', this.$t('range.shouldBeGreaterThanMin'));
                }
            }
        },
        checkChildrenInCare(feeTableValue) {
            if (!this.usingChildrenInCare) {
                return;
            }
            console.log(feeTableValue.childrenInCare);
            if (feeTableValue.childrenInCare.min !== null && feeTableValue.childrenInCare.max !== null) {
                this.clearFieldErrors(feeTableValue, 'childrenInCare.min');
                this.clearFieldErrors(feeTableValue, 'childrenInCare.max');
                if (feeTableValue.childrenInCare.max < feeTableValue.childrenInCare.min) {
                    this.addFieldError(feeTableValue, 'childrenInCare.max', this.$t('range.shouldNotBeLowerThanMin'));
                }
                if (feeTableValue.childrenInCare.min < FeeTableValue.CHILDREN_IN_CARE_MIN) {
                    this.addFieldError(feeTableValue, 'childrenInCare.min', this.$t('Dieser Wert sollte zwischen {min} und {max} liegen.', { min: FeeTableValue.CHILDREN_IN_CARE_MIN, max: FeeTableValue.CHILDREN_IN_CARE_MAX }));
                }
                if (feeTableValue.childrenInCare.max > FeeTableValue.CHILDREN_IN_CARE_MAX - 1) {
                    this.addFieldError(feeTableValue, 'childrenInCare.max', this.$t('Dieser Wert sollte zwischen {min} und {max} liegen.', { min: FeeTableValue.CHILDREN_IN_CARE_MIN, max: FeeTableValue.CHILDREN_IN_CARE_MAX - 1 }));
                }
            }
        },
        addNewFeeTableValue() {
            this.newValues.push(FeeTableValue.init(this.currency));
            this.emitInput();
        },
        markDeleted(index) {
            this.persistedValues[index].deleted = true;
        },
        unmarkDeleted(index) {
            this.persistedValues[index].deleted = false;
        },
        remove(index) {
            this.newValues.splice(index - this.persistedValues.length, 1);
            this.emitInput();
        },
        init() {
            this.persistedValues = this.feeTable.values.filter((feeTableValue) => feeTableValue.id !== null);
            this.newValues = this.feeTable.values.filter((feeTableValue) => feeTableValue.id === null);
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    $errorBgColor: rgba(244, 168, 54, 0.4);
.fee-table-value-delete {
    opacity: 0.3;
    text-decoration: line-through;
}
.fee-table-value-delete .kgr-input {
    text-decoration: line-through;
}
.fee-table-value-invalid {
    background-color: $errorBgColor;
}
.fee-table-value-invalid td {
    border: none;
}
.fee-table-value-invalid.bordered {
    border-bottom: 3px solid white;
}
.kgr-table__cell {
    vertical-align: top;
}
.kgr-table__cell--headline {
    text-align: center;
}
.kgr-table__cell--headline.bordered {
    border-right: 1px solid white;
}
.icon-info-position {
    vertical-align: middle;
    pointer-events: auto;
}
</style>
